import { useNavigate } from '@tanstack/react-router';
import { SimulationManager } from '@/components/SimulationManager';
import { useLayoutContext } from '@/contexts/useLayoutContext';
import type { SimulationSummary } from '@/types/api';

export function SimulationsPage() {
  const navigate = useNavigate();
  const { setSelectedSimulation, setResultsInfo } = useLayoutContext();

  const handleSelectSimulation = (sim: SimulationSummary) => {
    // Update layout context with selected simulation
    setSelectedSimulation(sim.id, sim.name);
    // Clear results when selecting a new simulation
    setResultsInfo(false, 0);
    // Navigate to the simulation config page
    navigate({ to: '/simulation/$simulationId', params: { simulationId: sim.id } });
  };

  return <SimulationManager onSelectSimulation={handleSelectSimulation} />;
}
